import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class FieldValidators {

  /**
   * Cross-field validator that checks two controls have matching values.
   * Apply to the FormGroup. The error is set on the controlToMark control.
   */
  static mustMatch(sourceControlName: string, matchControlName: string): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const source = group.get(sourceControlName);
      const match = group.get(matchControlName);

      if (!source || !match) return null;

      if (source.value && match.value && source.value !== match.value) {
        match.setErrors({ ...match.errors, mustMatch: true });
        return { mustMatch: true };
      }

      // Clear only the mustMatch error if values now match
      if (match.errors?.['mustMatch']) {
        const { mustMatch, ...rest } = match.errors;
        match.setErrors(Object.keys(rest).length ? rest : null);
      }

      return null;
    };
  }
  
  static passwordPattern(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,50}$/;
      return pattern.test(control.value) ? null : { passwordPattern: true };
    };
  };

  
}


